<script type="text/jsx" lang="jsx">
import BuyNow from './buy-now.vue';
import Trial2Paid from './trial-to-paid.vue';
import BuyTrial from './buy-trial.vue';
import Switch from './switch.vue';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    // In Vue 3, $listeners is merged into $attrs
    // Pass all props and attributes (including listeners) via $attrs
    if (this.$context.is.buyTrial) return <BuyTrial />;
    if (this.$context.is.trial2paid) return <Trial2Paid {...{ props: { ...this.$props }, ...this.$attrs }} />;
    if (this.$context.is.sdkpayg2uc) return <Switch {...{ props: { ...this.$props }, ...this.$attrs }} />;
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...{ props: { ...this.$props }, ...this.$attrs }} />;
    return null;
  },
};
</script>
